import { StrictMode } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';

import App from '@/App';
import { oidcConfig } from '@/auth';
import { ErrorBoundary } from '@/components';
import { BusinessDataProvider, MappingModalProvider, TutorialProvider } from '@/providers';
import CUCTheme from '@/styles/theme';

const rootElement = document.getElementById(import.meta.env.VITE_APP_ROOT_ELEMENT_ID ?? 'root');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      gcTime: 0,
      networkMode: 'online',
    },
  },
});

createRoot(rootElement!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <BrowserRouter>
        <ThemeProvider theme={CUCTheme}>
          <BusinessDataProvider>
            <MappingModalProvider>
              <QueryClientProvider client={queryClient}>
                <TutorialProvider>
                  <ErrorBoundary>
                    <App />
                    <ToastContainer position="bottom-right" autoClose={5000} pauseOnHover />
                    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
                  </ErrorBoundary>
                </TutorialProvider>
              </QueryClientProvider>
            </MappingModalProvider>
          </BusinessDataProvider>
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
